export const type = 'entrance_planner'

export const programTypeCookie = 'programTypePlanner'
